import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustStrip from "./components/TrustStrip";
import About from "./components/About";
import Services from "./components/Services";
import Institutions from "./components/Institutions";
import Process from "./components/Process";
import StatsBand from "./components/StatsBand";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import { CtaBand, Footer } from "./components/CtaAndFooter";

export default function App() {
  return (
    <>
      <Header />
      <Hero />
      <TrustStrip />
      <About />
      <Services />
      <Institutions />
      <Process />
      <StatsBand />
      <Reviews />
      <Contact />
      <CtaBand />
      <Footer />
    </>
  );
}
